import { render, staticRenderFns } from "./TrainingCourses.vue?vue&type=template&id=6a6f7682"
import script from "./TrainingCourses.vue?vue&type=script&lang=js"
export * from "./TrainingCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports